import { createActionGroup, props } from '@ngrx/store';

export const vacancySearchExistsGuardActions = createActionGroup({
  source: 'Vacancy Search Exists Guard',
  events: { 'Can Activate': props<{ vacancyId: string }>() },
});
